// Holds the currently-selected SharePoint site id for the multi-site add-in.
// Kept in a tiny standalone module (no MSAL/Graph imports) so both the storage
// proxy and the Graph service can read/write it synchronously without a load.
let currentSiteId: string | null = null;

export const siteContext = {
  getSiteId: (): string | null => currentSiteId,
  setSiteId: (id: string | null): void => {
    currentSiteId = id;
  },
};
